export default {
  image: 'Image',
  clickToExpandImage: 'Click to expand image',
  viewImageOptions: 'View image options',
  alignLeft: 'Align left',
  center: 'Center',
  alignRight: 'Align right',
  alignTop: 'Align top',
  alignBottom: 'Align bottom',
  changeImage: 'Change image',
  deleteImage: 'Delete image',
  selectOrDragImageHere: 'Select or drag the image here...',
  dragImageHere: 'Drag the image here...',
  imageDeletedSuccessfully: 'Image deleted.',
}
